import * as React from "react"
import {useState} from "react"
// @ts-ignore
import {RegisterForm} from "../molecules/RegisterForm"
import {ModalPopup} from "../molecules/ModalPopup"
import {SigninForm} from "../molecules/SigninForm"

const FinalCTA = () => {
    const [activeModal, setActiveModal] = useState('')

    return (
        <section className="w-full bg-emerald-50 py-24">
            <div className="max-w-3xl mx-auto px-6 text-center">
                <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 tracking-tight">
                    Ready to send your first campaign?
                </h2>
                <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">
                    Set up your account in minutes. No credit card required.
                </p>
                <div className="mt-8 flex justify-center">
                    <button
                        type="button"
                        onClick={() => setActiveModal('signup')}
                        className="rounded-full px-8 py-4 bg-emerald-500 hover:bg-emerald-600 text-white text-base font-semibold shadow-sm transition-colors duration-200">
                        Get started free
                    </button>
                </div>
            </div>

            {activeModal !== '' && (
                <ModalPopup
                    onClose={() => setActiveModal('')}
                    children={activeModal === 'login' ?
                        <SigninForm onClose={() => setActiveModal('')}/> :
                        <RegisterForm onClose={() => setActiveModal('')}/>}
                    heading={activeModal === 'login' ? "SignIn" : "Signup"}
                    description={activeModal === 'login' ?
                        "Enter verification ID sent from Neugence Marketing" :
                        "Enter your email to register."}/>
            )}
        </section>
    )
}

export default FinalCTA
